export const styleVariables = {
  background: '#303030',
  primary: '#00eded',
  secondary: '#e2e2e2',
  margin: '15px',
};



// WEBPACK FOOTER //
// ./src/styles/variables.js